const CourierFAQContentKeys = [
    {
        questionKey : 'new_productoverview_courier.FAQ_QUESTION1',
        answerKey: 'new_productoverview_courier.FAQ_QUESTION_1_ANSWER'
    },
    {
        questionKey : 'new_productoverview_courier.FAQ_QUESTION2',
        answerKey: 'new_productoverview_courier.FAQ_QUESTION_2_ANSWER'
    },
    {
        questionKey : 'new_productoverview_courier.FAQ_QUESTION3',
        answerKey: 'new_productoverview_courier.FAQ_QUESTION_3_ANSWER'
    },
    {
        questionKey : 'new_productoverview_courier.FAQ_QUESTION4',
        answerKey: 'new_productoverview_courier.FAQ_QUESTION_4_ANSWER'
    },
    {
        questionKey : 'new_productoverview_courier.FAQ_QUESTION5',
        answerKey: 'new_productoverview_courier.FAQ_QUESTION_5_ANSWER'
    },
    {
        questionKey : 'new_productoverview_courier.FAQ_QUESTION6',
        answerKey: 'new_productoverview_courier.FAQ_QUESTION_6_ANSWER'
    },
    {
        questionKey : 'new_productoverview_courier.FAQ_QUESTION7',
        answerKey: 'new_productoverview_courier.FAQ_QUESTION_7_ANSWER'
    },
    {
        questionKey : 'new_productoverview_courier.FAQ_QUESTION8',
        answerKey: 'new_productoverview_courier.FAQ_QUESTION_8_ANSWER'
    },
    {
        questionKey : 'new_productoverview_courier.FAQ_QUESTION9',
        answerKey: 'new_productoverview_courier.FAQ_QUESTION_9_ANSWER'
    },
    {
        questionKey : 'new_productoverview_courier.FAQ_QUESTION10',
        answerKey: 'new_productoverview_courier.FAQ_QUESTION_10_ANSWER'
    },
    // {
    //     questionKey : 'courieroverview.FAQ_QUESTION_11',
    //     answerKey: 'courieroverview.FAQ_QUESTION_11_ANSWER'
    // },
]

export default CourierFAQContentKeys